// @ts-strict-ignore
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleVO } from '@article/model/vo/article.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleUtils } from '@article/util/article-utils';

@Component({
  standalone: false,
  selector: 'app-project-loading-outdated-articles',
  templateUrl: './project-loading-outdated-articles.component.html'
})
export class ProjectLoadingOutdatedArticlesComponent implements OnInit, AfterViewInit, OnDestroy {

  public outdatedArticles: ArticleVO[] = [];

  public configurationName: string;

  public materialstatus: number;

  public lastCallDate: Date;

  public isWagoUser: boolean;


  constructor(private _bsModalRef: BsModalRef, private localeResourceManager: LocaleResourceManager) { }

  public ngOnInit(): void {

  }

  public ngAfterViewInit(): void { }

  public ngOnDestroy(): void {

  }

  public close(): void {
    this._bsModalRef.hide();
  }

  public getOutdatedConfigurationLabel(): string {
    if (!ArticleUtils.isStatusOutdated(this.materialstatus)) {
      return '';
    }
    let text = ArticleUtils.getOutdatedConfigurationText(this.localeResourceManager, this.configurationName, this.materialstatus, this.lastCallDate);
    if (this.isWagoUser) {
      text = text + ' ' + this.localeResourceManager.getValueByKey('outdatedArticlesAlert.materialstatus', [this.materialstatus]);
    }
    return text;
  }

  public getOutdatedArticleLabel(article: ArticleVO): string {
    return ArticleUtils.getOutdatedArticleLabel(this.localeResourceManager, article);
  }
}
